var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link 1",
    clipPath: "url(#clip0_217_1548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.93957 13.0576C5.88087 14.1554 4.15673 14.2567 2.97682 13.2903C2.27413 12.6819 1.91519 11.7671 2.01664 10.8432C2.1045 10.162 2.42288 9.53135 2.91881 9.05617L4.83652 7.13715C5.22696 6.74658 5.22696 6.11346 4.83652 5.72289C4.44594 5.33244 3.81282 5.33244 3.42225 5.72289L1.54524 7.60059C0.689645 8.42565 0.150075 9.52432 0.0202691 10.7058C-0.222183 13.3669 1.73847 15.7206 4.39953 15.9631C5.82858 16.0933 7.24172 15.5824 8.25712 14.5685L10.2628 12.5635C10.6533 12.1729 10.6533 11.5398 10.2628 11.1492C9.87227 10.7588 9.23915 10.7588 8.84858 11.1492L6.93957 13.0576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1075 0.977953C12.1163 -0.485009 9.35124 -0.255653 7.62829 1.5154L5.74059 3.40375C5.35014 3.79432 5.35014 4.42744 5.74059 4.81802C6.13116 5.20846 6.76428 5.20846 7.15485 4.81802L9.07256 2.90231C10.1081 1.83127 11.7836 1.71062 12.9619 2.62226C14.1748 3.61676 14.3518 5.40613 13.3573 6.61895C13.2991 6.68993 13.2375 6.75804 13.1726 6.82305L11.1669 8.82877C10.7765 9.21934 10.7765 9.85246 11.1669 10.243C11.5575 10.6335 12.1906 10.6335 12.5812 10.243L14.5869 8.23731C16.4752 6.34302 16.4703 3.27666 14.576 1.3884C14.4288 1.24169 14.2723 1.1046 14.1075 0.977953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.74071 8.83056L8.84832 5.72295C9.23893 5.33234 9.8722 5.33234 10.2628 5.72295C10.6534 6.11355 10.6534 6.74683 10.2628 7.13743L7.15519 10.245C6.76459 10.6356 6.13131 10.6356 5.74071 10.245C5.3501 9.85444 5.3501 9.22116 5.74071 8.83056Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_1548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.599e32d5e29b58ecf3770336c2f23a5c.svg";
export { ForwardRef as ReactComponent };